export default {
  others: 'outros'
}
